export enum RankingType {
  Static = 'Static',
  Theme = 'Theme',
}
